
import { ENABLE_FCM_WEB } from "config/FeatureFlag";
import firebase from "firebase/compat/app";
import "firebase/compat/messaging";
export function register() {
  if ("serviceWorker" in navigator && ENABLE_FCM_WEB) {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then(() => {
        firebase.initializeApp({
          // Project Settings => Add Firebase to your web app
            apiKey: "AIzaSyC23jKgjKiAfar6pH6d6Q-latmi5mJfUM8",
            authDomain: "hellohealth-5788f.firebaseapp.com",
            projectId: "hellohealth-5788f",
            storageBucket: "hellohealth-5788f.appspot.com",
            messagingSenderId: "381587704754",
            appId: "1:381587704754:web:e57ee4d62efbced6c672ab"
        });
      })
      .catch(function (err) {
        // console.log("firebase Service worker registration failed, error:", err);
      });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator && ENABLE_FCM_WEB) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
